import { render, staticRenderFns } from "./authRole.vue?vue&type=template&id=1b9e5b12"
import script from "./authRole.vue?vue&type=script&lang=js"
export * from "./authRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports